// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    LocationAddressModel,
    LocationCityModels,
    LocationSharedStateModels,
    LocationValidAddressModelResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class LocationV1Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Gets All States.
     */
    public async getAllStates (): Promise<AxiosResponse<LocationSharedStateModels>> {
        const _url_ = '/location/v1/State';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<LocationSharedStateModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LocationSharedStateModels");
        }
        return response;
    }
    /**
     * 
     * @summary Gets a list of City records related to the specified Zip code
     * @param zipCode 
     */
    public async getCitiesByZip (zipCode?: string): Promise<AxiosResponse<LocationCityModels>> {
        const _url_ = '/location/v1/City';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (zipCode !== undefined) {
            _params_['zipCode'] = Serializer.serialize(zipCode, "string");
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<LocationCityModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LocationCityModels");
        }
        return response;
    }
    /**
     * 
     * @summary Gets a Private City related to the specified Zip code
     * @param zipCode 
     */
    public async getPrimaryCityByZip (zipCode?: string): Promise<AxiosResponse<LocationCityModels>> {
        const _url_ = '/location/v1/PrimaryCity';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (zipCode !== undefined) {
            _params_['zipCode'] = Serializer.serialize(zipCode, "string");
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<LocationCityModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LocationCityModels");
        }
        return response;
    }
    /**
     * 
     * @summary Validate an address
     * @param locationAddressModel The address to validate
     */
    public async validAddress (locationAddressModel: LocationAddressModel): Promise<AxiosResponse<LocationValidAddressModelResponse>> {
        const _url_ = '/location/v1/ValidAddress';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'locationAddressModel' is not null or undefined
        if (locationAddressModel === null || locationAddressModel === undefined) {
            throw new Error('Required parameter locationAddressModel was null or undefined when calling validAddress.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(locationAddressModel, "LocationAddressModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<LocationValidAddressModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LocationValidAddressModelResponse");
        }
        return response;
    }
}
